import React from 'react'
import {
  HourAgo,
  StyleConversationList,
  StyleConversationListWrapper,
  StyleLatestMessage,
  TimeStatusWrapper,
} from '../style'

import { useDispatch, useSelector } from 'react-redux'
import { Actions, RootState } from '@store/index'
import { useLocation, useNavigate } from 'react-router-dom'
import { StyleAvatar, StyleName } from '@commons/chats/style'
import useIsMobile from '@hooks/useIsMobile'

const ConversationLists = ({ title, data }) => {
  const isMobile = useIsMobile()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const selectedChat = useSelector((state: any) => state.selectedChat)

  const handleSelectChat = (chat) => {
    dispatch(Actions.set('selectedChat', chat))
    const basePath = location.pathname.split('/').slice(0, 3).join('/')
    const safeName = encodeURIComponent(chat.name)
    navigate(`${basePath}/${safeName}`, { replace: false })
  }

  const isActive = (item) => selectedChat?.name === item.name

  return (
    <StyleConversationListWrapper>
      {(!isMobile || (isMobile && !selectedChat)) &&
        (data.length === 0 ? (
          <p style={{ padding: '1rem' }}>No conversations found for {title}.</p>
        ) : (
          data.map((item, index) => (
            <StyleConversationList
              key={index}
              onClick={() => handleSelectChat(item)}
              active={isActive(item)}
            >
              <StyleAvatar src={item.avatar} alt={item.name} />
              <div
                style={{ display: 'flex', flexDirection: 'column', flex: 1 }}
              >
                <StyleName style={{ fontSize: isMobile ? '12px' : undefined }}>
                  {isMobile ? item.name.split(' ')[0] : item.name}
                </StyleName>

                {!isMobile && (
                  <StyleLatestMessage>
                    {item.latestMessage || 'No message yet'}
                  </StyleLatestMessage>
                )}
              </div>

              {!isMobile && (
                <TimeStatusWrapper>
                  <HourAgo>{item.time || 'Just now'}</HourAgo>
                </TimeStatusWrapper>
              )}
            </StyleConversationList>
          ))
        ))}
    </StyleConversationListWrapper>
  )
}

export default ConversationLists
